import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card } from '../../components/common/GlobalElements/Card';
import { Heading4 } from '../../components/common/GlobalElements/Typography';

function Home(props) {
    const brand = useSelector((state) => state.brand);

    return (
        <div className="lib-home-right">
            {/* <div className="header-info-box">
        <h4>Library Home</h4>
        <p>Welcome to LIBRARY @{brand?.configuration?.brand_name}. Here you can search for any academic information regarding your projects, class discussions or any other interesting topic. The library consists of books found in our campus libraries as well as online resource such nas links, videos, online documents and articles.</p>
      </div> */}
            <div className="card-list-blk">
                <ul className="card-grid home-ul-list list-unstyled">
                    <li>
                        <Link className="home-link" to={'/student-hub/advance-search/query'}>
                            <Card padding="25px 5px 35px" className="card home-bx-card">
                                <div class="icon">
                                    <i class="fal fa-search-plus"></i>
                                </div>
                                <div className="home-bx-card-info">
                                    <Heading4>Search Library</Heading4>
                                    <p>Search by category & advanced filter.</p>
                                </div>
                            </Card>
                        </Link>
                    </li>
                    <li>
                        <Link className="home-link" to={'/student-hub/research-assistance'}>
                            <Card padding="25px 5px 35px" className="card home-bx-card">
                                <div class="icon">
                                    <i class="fal fa-print-search"></i>
                                </div>
                                <div className="home-bx-card-info">
                                    <Heading4>Research Assistance</Heading4>
                                    <p>Information search Lab Access/Bookings.</p>
                                </div>
                            </Card>
                        </Link>
                    </li>
                    <li>
                        <Link className="home-link" to={'/student-hub/search-assistance'}>
                            <Card padding="25px 5px 35px" className="card home-bx-card">
                                <div class="icon">
                                    <i class="fal fa-hands-helping"></i>
                                </div>
                                <div className="home-bx-card-info">
                                    <Heading4>Search Assistance</Heading4>
                                    <p>Request for help from a librarian.</p>
                                </div>
                            </Card>
                        </Link>
                    </li>
                    <li>
                        <Link className="home-link" to={'/student-hub/campus-library'}>
                            <Card padding="25px 5px 35px" className="card home-bx-card">
                                <div class="icon">
                                    <i class="fal fa-university"></i>
                                </div>
                                <div className="home-bx-card-info">
                                    <Heading4>Campus Libraries</Heading4>
                                    <p>Get important information of direct interest to you.</p>
                                </div>
                            </Card>
                        </Link>
                    </li>
                    <li>
                        <Link className="home-link" to={'/student-hub/student-support'}>
                            <Card padding="25px 5px 35px" className="card home-bx-card">
                                <div class="icon">
                                    <i class="fal fa-headset"></i>
                                </div>
                                <div className="home-bx-card-info">
                                    <Heading4>Student Support</Heading4>
                                    <p>Options to contact the AIE support team</p>
                                </div>
                            </Card>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Home;
